import { ArrowDownOutlined, ArrowUpOutlined, CalendarOutlined, FontSizeOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import type React from 'react';

import Button from '~/shared/components/form-fields/button';
import ResponsiveTooltip from '~/shared/components/responsive-tooltip';

import './sorting.scss';

type SortingProps = {
  t: (key: string) => string;
  isNameSortDesc: boolean | null;
  isDateSortDesc: boolean | null;
  isNameSortDisabled?: boolean;
  onNameSortClick: () => void;
  onDateSortClick: () => void;
  isDateSortDisabled?: boolean;
  variant?: 'default' | 'compact';
};

const renderSortIcon = (icon: React.ReactNode, isActive: boolean, isDesc: boolean | null) => {
  const ArrowIcon = isDesc ? ArrowDownOutlined : ArrowUpOutlined;

  return (
    <span className="sorting__icon">
      <span className="sorting__main-icon">{icon}</span>

      {isActive && (
        <span className="sorting__direction-icon">
          <ArrowIcon />
        </span>
      )}
    </span>
  );
};

const Sorting = ({
  t,
  isNameSortDesc,
  isDateSortDesc,
  isNameSortDisabled = false,
  onNameSortClick,
  onDateSortClick,
  isDateSortDisabled = false,
  variant = 'default',
}: SortingProps) => {
  const isCompact = variant === 'compact';

  const isNameActive = isNameSortDesc !== null;
  const isDateActive = isDateSortDesc !== null;

  return (
    <div
      className={classNames('sorting', {
        'sorting--compact': isCompact,
      })}
    >
      <Button
        className={classNames({
          'action-button--yellow': isNameActive,
          'action-button--yellow-white': !isNameActive,
          sorting__button: true,
          'sorting__button--compact': isCompact,
        })}
        disabled={isNameSortDisabled}
        size={isCompact ? 'small' : 'middle'}
        onClick={onNameSortClick}
      >
        <ResponsiveTooltip title={t(!isNameSortDesc ? 'text.sort-by-name-asc' : 'text.sort-by-name-desc')}>
          {renderSortIcon(<FontSizeOutlined />, isNameActive, isNameSortDesc)}
        </ResponsiveTooltip>
      </Button>

      <Button
        className={classNames({
          'action-button--yellow': isDateActive,
          'action-button--yellow-white': !isDateActive,
          sorting__button: true,
          'sorting__button--compact': isCompact,
        })}
        disabled={isDateSortDisabled}
        size={isCompact ? 'small' : 'middle'}
        onClick={onDateSortClick}
      >
        <ResponsiveTooltip
          title={t(!isDateSortDesc ? 'text.sort-by-date-of-creation-asc' : 'text.sort-by-date-of-creation-desc')}
        >
          {renderSortIcon(<CalendarOutlined />, isDateActive, isDateSortDesc)}
        </ResponsiveTooltip>
      </Button>
    </div>
  );
};

export default Sorting;
